import { render } from "./multiple.vue?vue&type=template&id=1e879178&scoped=true&ts=true&lang=pug"
import script from "./multiple.vue?vue&type=script&lang=ts"
export * from "./multiple.vue?vue&type=script&lang=ts"

import "./multiple.vue?vue&type=style&index=0&id=1e879178&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e879178"]])

export default __exports__